/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GiftCardIssuanceStatus } from './GiftCardIssuanceStatus';
import {
    GiftCardIssuanceStatusFromJSON,
    GiftCardIssuanceStatusFromJSONTyped,
    GiftCardIssuanceStatusToJSON,
    GiftCardIssuanceStatusToJSONTyped,
} from './GiftCardIssuanceStatus';
import type { RewardType } from './RewardType';
import {
    RewardTypeFromJSON,
    RewardTypeFromJSONTyped,
    RewardTypeToJSON,
    RewardTypeToJSONTyped,
} from './RewardType';
import type { DistributedRewardSubject } from './DistributedRewardSubject';
import {
    DistributedRewardSubjectFromJSON,
    DistributedRewardSubjectFromJSONTyped,
    DistributedRewardSubjectToJSON,
    DistributedRewardSubjectToJSONTyped,
} from './DistributedRewardSubject';
import type { NotificationMetadata } from './NotificationMetadata';
import {
    NotificationMetadataFromJSON,
    NotificationMetadataFromJSONTyped,
    NotificationMetadataToJSON,
    NotificationMetadataToJSONTyped,
} from './NotificationMetadata';

/**
 * 
 * @export
 * @interface DistributedRewardResponse
 */
export interface DistributedRewardResponse {
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    id: string;
    /**
     * The RewardConfig that paid this distribution (legacy path). Exactly one of rewardConfigId | catalogItemId is set.
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    rewardConfigId?: string;
    /**
     * The reward catalog item a grant-born distribution was resolved from. Exactly one of rewardConfigId | catalogItemId is set.
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    catalogItemId?: string;
    /**
     * 
     * @type {number}
     * @memberof DistributedRewardResponse
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    userId: string;
    /**
     * 
     * @type {DistributedRewardSubject}
     * @memberof DistributedRewardResponse
     */
    subject: DistributedRewardSubject;
    /**
     * 
     * @type {boolean}
     * @memberof DistributedRewardResponse
     */
    webNotificationDismissed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DistributedRewardResponse
     */
    devourPlayNotificationDismissed: boolean;
    /**
     * 
     * @type {RewardType}
     * @memberof DistributedRewardResponse
     */
    type?: RewardType;
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    description?: string;
    /**
     * 
     * @type {NotificationMetadata}
     * @memberof DistributedRewardResponse
     */
    notificationMetadata?: NotificationMetadata;
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    promoTokenId?: string;
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    couponCode?: string;
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    targetUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    qrImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    leaderboardCompetitionId?: string;
    /**
     * Tournament this distribution belongs to. Stamped on tournament rank-reward grants so a re-run can tell an already-paid winner from a new one.
     * @type {string}
     * @memberof DistributedRewardResponse
     */
    tournamentId?: string;
    /**
     * 
     * @type {GiftCardIssuanceStatus}
     * @memberof DistributedRewardResponse
     */
    giftCardStatus?: GiftCardIssuanceStatus;
    /**
     * 
     * @type {number}
     * @memberof DistributedRewardResponse
     */
    updatedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof DistributedRewardResponse
     */
    createdAt?: number;
}



/**
 * Check if a given object implements the DistributedRewardResponse interface.
 */
export function instanceOfDistributedRewardResponse(value: object): value is DistributedRewardResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('webNotificationDismissed' in value) || value['webNotificationDismissed'] === undefined) return false;
    if (!('devourPlayNotificationDismissed' in value) || value['devourPlayNotificationDismissed'] === undefined) return false;
    return true;
}

export function DistributedRewardResponseFromJSON(json: any): DistributedRewardResponse {
    return DistributedRewardResponseFromJSONTyped(json, false);
}

export function DistributedRewardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributedRewardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'rewardConfigId': json['rewardConfigId'] == null ? undefined : json['rewardConfigId'],
        'catalogItemId': json['catalogItemId'] == null ? undefined : json['catalogItemId'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'userId': json['userId'],
        'subject': DistributedRewardSubjectFromJSON(json['subject']),
        'webNotificationDismissed': json['webNotificationDismissed'],
        'devourPlayNotificationDismissed': json['devourPlayNotificationDismissed'],
        'type': json['type'] == null ? undefined : RewardTypeFromJSON(json['type']),
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'notificationMetadata': json['notificationMetadata'] == null ? undefined : NotificationMetadataFromJSON(json['notificationMetadata']),
        'promoTokenId': json['promoTokenId'] == null ? undefined : json['promoTokenId'],
        'couponCode': json['couponCode'] == null ? undefined : json['couponCode'],
        'targetUrl': json['targetUrl'] == null ? undefined : json['targetUrl'],
        'qrImageUrl': json['qrImageUrl'] == null ? undefined : json['qrImageUrl'],
        'leaderboardCompetitionId': json['leaderboardCompetitionId'] == null ? undefined : json['leaderboardCompetitionId'],
        'tournamentId': json['tournamentId'] == null ? undefined : json['tournamentId'],
        'giftCardStatus': json['giftCardStatus'] == null ? undefined : GiftCardIssuanceStatusFromJSON(json['giftCardStatus']),
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
    };
}

export function DistributedRewardResponseToJSON(json: any): DistributedRewardResponse {
    return DistributedRewardResponseToJSONTyped(json, false);
}

export function DistributedRewardResponseToJSONTyped(value?: DistributedRewardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'rewardConfigId': value['rewardConfigId'],
        'catalogItemId': value['catalogItemId'],
        'amount': value['amount'],
        'userId': value['userId'],
        'subject': DistributedRewardSubjectToJSON(value['subject']),
        'webNotificationDismissed': value['webNotificationDismissed'],
        'devourPlayNotificationDismissed': value['devourPlayNotificationDismissed'],
        'type': RewardTypeToJSON(value['type']),
        'name': value['name'],
        'description': value['description'],
        'notificationMetadata': NotificationMetadataToJSON(value['notificationMetadata']),
        'promoTokenId': value['promoTokenId'],
        'couponCode': value['couponCode'],
        'targetUrl': value['targetUrl'],
        'qrImageUrl': value['qrImageUrl'],
        'leaderboardCompetitionId': value['leaderboardCompetitionId'],
        'tournamentId': value['tournamentId'],
        'giftCardStatus': GiftCardIssuanceStatusToJSON(value['giftCardStatus']),
        'updatedAt': value['updatedAt'],
        'createdAt': value['createdAt'],
    };
}

